import { DateTreated } from '@/core/domain/people/Customers/Customers.types';
import { useChartTheme } from '@/hooks';
import { metricPrefixFormatter } from '@/utils/number';
import { ResponsiveBar } from '@nivo/bar';
import { Card, Typography } from 'antd';

interface Props {
  dateTreated: DateTreated;
  baseColor: string[];
}

export default function CustomerAverageAgeBars({
  dateTreated,
  baseColor,
}: Props) {
  const [maleColor, femaleColor, unspecifiedColor, otherColor] = baseColor;
  const theme = useChartTheme();
  const generalAverage =
    (dateTreated?.averageAgeMaleCustomers || 0) +
    (dateTreated?.averageAgeFemaleCustomers || 0) +
    (dateTreated?.averageAgeGenderUnspecifiedCustomers || 0);

  return (
    <Card style={{ borderRadius: 4 }}>
      <Typography.Title level={4} style={{ textAlign: 'center' }}>
        Média de idade
      </Typography.Title>
      <div style={{ height: 300 }}>
        <ResponsiveBar
          margin={{ top: 24, right: 24, bottom: 48, left: 48 }}
          colors={(data) => data.data.color}
          tooltipLabel={({ data }) => data.status}
          valueFormat={(value) => `${value.toFixed(0)} anos`}
          data={[
            {
              status: 'Homens',
              color: maleColor,
              value: Math.round(dateTreated?.averageAgeMaleCustomers || 0),
            },
            {
              status: 'Mulheres',
              color: femaleColor,
              value: Math.round(dateTreated?.averageAgeFemaleCustomers || 0),
            },
            {
              status: 'Não especificados',
              color: unspecifiedColor,
              value: Math.round(
                dateTreated?.averageAgeGenderUnspecifiedCustomers || 0,
              ),
            },
            {
              status: 'Média geral',
              color: otherColor,
              value: Math.round(generalAverage / 3 || 0),
            },
          ]}
          indexBy="status"
          valueScale={{ type: 'linear' }}
          indexScale={{ type: 'band', round: true }}
          axisLeft={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            tickValues: 5,
            format: (value) => metricPrefixFormatter(value),
            legendOffset: -50,
            legendPosition: 'middle',
          }}
          theme={theme}
        />
      </div>
    </Card>
  );
}
